import React, { useEffect, useRef, useState } from "react";
import "./lcpImage.css";

function LCPImage({ src, alt, className, width, height, onLoad }) {
  const imgRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [src]);

  useEffect(() => {
    const img = imgRef.current;
    if (img?.complete && img.naturalWidth > 0) {
      setLoaded(true);
      onLoad?.();
    }
  }, [src, onLoad]);

  const handleLoad = () => {
    setLoaded(true);
    onLoad?.();
  };

  return (
    <div className={`lcp-image ${loaded ? "lcp-image--loaded" : ""}`}>
      <div className="lcp-image__placeholder" aria-hidden="true" />
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={`lcp-image__img ${className || ""}`}
        onLoad={handleLoad}
        decoding="async"
        fetchPriority="high"
      />
    </div>
  );
}

export default LCPImage;
